import axiosInstance from "../../config/axiosInstance";

const getOperationRequest = async operationId => {
  return await axiosInstance.dillApi().get("/operations/" + operationId);
};

export default getOperationRequest;
